var _rect, _path, _g, _path2, _g2, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMorphoAaveV3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#14183D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M6.14062 14.5676V18.7309C6.14062 18.9872 6.35752 19.0936 6.42499 19.1177C6.49247 19.1468 6.71901 19.2096 6.92147 19.021L10.4739 15.6072C10.8016 15.1817 10.9221 14.9158 10.9221 14.9158C11.1149 14.5241 11.1149 14.1469 10.9268 13.7698C10.6473 13.2088 9.9339 12.6382 8.85912 12.0967L7.0227 13.1218C6.47803 13.4313 6.14062 13.9777 6.14062 14.5676Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_573_18863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.2998 5.308V9.67442C4.2998 10.2208 4.66615 10.7044 5.18671 10.8591C6.96048 11.3717 10.0501 12.4741 10.7973 14.094C10.8935 14.3068 10.9515 14.5147 10.9707 14.7323C11.4672 13.8281 11.6937 12.7884 11.5878 11.7343C11.4432 10.2402 10.6526 8.8814 9.41867 8.01586L5.01799 4.93567C4.94087 4.87765 4.84929 4.84863 4.75771 4.84863C4.68059 4.84863 4.6131 4.86314 4.54081 4.90182C4.3962 4.98403 4.2998 5.13393 4.2998 5.308Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M17.8558 14.5676V18.7309C17.8558 18.9872 17.639 19.0936 17.5715 19.1177C17.5039 19.1468 17.2774 19.2096 17.075 19.021L13.5226 15.6072C13.1949 15.1817 13.0744 14.9158 13.0744 14.9158C12.8816 14.5241 12.8816 14.1469 13.0694 13.7698C13.349 13.2088 14.0624 12.6382 15.1374 12.0967L16.9738 13.1218C17.5232 13.4313 17.8558 13.9777 17.8558 14.5676Z",
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_573_18863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 5.30751V9.67392C19.7 10.2203 19.3337 10.7039 18.813 10.8586C17.0392 11.3712 13.9497 12.4736 13.2026 14.0935C13.1061 14.3063 13.0483 14.5142 13.029 14.7318C12.5326 13.8276 12.3061 12.7879 12.4121 11.7338C12.5567 10.2397 13.3472 8.88092 14.581 8.01536L18.9817 4.93518C19.0588 4.87716 19.1504 4.84814 19.2421 4.84814C19.3193 4.84814 19.3867 4.86265 19.4589 4.90133C19.6036 4.98354 19.7 5.13344 19.7 5.30751Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "url(#paint0_linear_573_18863)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 11.9999,
    height: 11.9999,
    rx: 5.99997,
    fill: "url(#paint1_linear_573_18863)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 1,
    height: 6,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_573_18863",
    x: 0.773397,
    y: 2.73279,
    width: 14.3663,
    height: 16.9366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41056
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_18863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_18863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_573_18863",
    x: 8.86007,
    y: 2.7323,
    width: 14.3663,
    height: 16.9366,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.41056
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.7632
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_573_18863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_573_18863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_18863",
    x1: -0.792001,
    y1: 22.92,
    x2: 24.792,
    y2: 5.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EBAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6509E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_18863",
    x1: 11.604,
    y1: 23.4599,
    x2: 24.3959,
    y2: 14.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2EBAC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6509E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorphoAaveV3);
export default __webpack_public_path__ + "static/media/morpho-aave-v3.90999cfad72bd03341ec1ae5f95ca6b9.svg";
export { ForwardRef as ReactComponent };